import type { ComponentProps, CSSProperties } from "react"
import cn from "@/v2-ui/utils/utils.cn"

function BadgeX(props: ComponentProps<"svg">) {
  const {
    className,
    style,
    stroke = "currentColor",
    strokeWidth = 2,
    strokeLinecap = "round",
    strokeLinejoin = "round",
    fill: _ignoredFill,
    width: _ignoredWidth,
    height: _ignoredHeight,
    ...svgProps
  } = props

  const sizeStyle: CSSProperties = {
    width: style?.width ?? 16,
    height: style?.height ?? 16,
    flexShrink: 0,
    ...style,
  }

  return (
    <svg
      className={cn("block", className)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={sizeStyle}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      aria-hidden
      {...svgProps}
    >
      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
      <line x1="15" x2="9" y1="9" y2="15" />
      <line x1="9" x2="15" y1="9" y2="15" />
    </svg>
  )
}

export default BadgeX
